import React from "react"; 
import { Routes, Route } from "react-router-dom";
import './App.css';
import './css/reports.css'
import Home from './pages/Home/Home';
import NoMatch from './pages/no-match/NoMatch';
import Cybersecurity from "./pages/cybersecurity/home-cibersecurity/HomeCybersecurity";
import Interconnection from "./pages/interconnection/home-interconnection/HomeInterconnection";
import IPv6 from "./pages/IPv6/home-ipv6/HomeIPv6";
import { useScrollToTop } from "./hooks/useScrollToTop";

export default function App() {  
  useScrollToTop();
  // Definir los slugs para cada idioma
  const slugs = {
    es: {
      ciberseguridad: 'ciberseguridad',
      interconexion: 'interconexion',
      ipv6: 'ipv6'
    },
    en: {
      ciberseguridad: 'cybersecurity',
      interconexion: 'interconnection',
      ipv6: 'ipv6'
    },
    pt: {
      ciberseguridad: 'ciberseguranca',
      interconexion: 'interconexao',
      ipv6: 'ipv6'
    }
  };
    
  
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home routes={slugs}/>} />
        <Route path="/:lang/*" element={<Home routes={slugs}/>} /> 
        
        {Object.entries(slugs).map(([lang, routes]) => (
          <React.Fragment key={lang}> 
            <Route path={`/${lang}/${routes.ciberseguridad}/*`} element={<Cybersecurity lang={lang} routes={routes} myRoutes={slugs} />} />
            <Route path={`/${lang}/${routes.interconexion}/*`} element={<Interconnection lang={lang} routes={routes} myRoutes={slugs}  />} />
            <Route path={`/${lang}/${routes.ipv6}/*`} element={<IPv6 lang={lang} routes={routes} myRoutes={slugs}   />} />
          </React.Fragment>
        ))}
        
        
        <Route path="*" element={<NoMatch />} />
      </Routes> 
    </div>
  )
}
